<div *ngIf="valuesLoading()" class="row">
  <div class="col-md-12">
    Pre-Filter Values Still Loading, options will become avaiable once the data is loaded.
  </div>
</div>
<div class="row">
  <div class="col-md-4">
    <div class="row segment-border">
      <div class="row title-row">
        <p>
          <b>Select Job Titles to Include</b>
        </p>
      </div>
      <div class="row input-row">
        <div class="col-md-10 input-column">
          <mat-chip-list #titleChipList>
            <div class="mat-input">
              <input placeholder="Title Search..."
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputFor]="titleChipList"
                     [matChipInputAddOnBlur]="true"
                     (matChipInputTokenEnd)="addTitleSearch($event)"/>
            </div>
            <mat-chip *ngFor="let title of titleSearch" [selectable]="true" [removable]="true" (removed)="removeTitleSearch(title)">
              {{title}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="col-md-1 button-column">
          <button mat-button class="piButton" (click)="toggleTitleAndOr()">
            <ng-container *ngIf="titleIsAnd">And</ng-container>
            <ng-container *ngIf="!titleIsAnd">Or</ng-container>
          </button>
        </div>
      </div>
    </div>
    <div class="row segment-border segment-fixed-height">
      <div class="row title-row" *ngIf="loadingTitles">
        <i class="fas fa-spinner fa-pulse"></i> Loading Titles...
      </div>
      <div class="col-md-12" *ngIf="!loadingTitles">
        <div class="row tree-row">
          <tree-editor #titlesTree [avaialbleTreeEditorNodes]="availableTitles"></tree-editor>
        </div>
      </div>
    </div>
    <div class="row segment-border segment-fixed-height">
      <div class="row title-row" *ngIf="loadingOccupations">
        <i class="fas fa-spinner fa-pulse"></i> Loading Occupations...
      </div>
      <div class="col-md-12" *ngIf="!loadingOccupations">
        <div class="row title-row">
          <p>
            <b>Select Occupations to Include</b>
          </p>
        </div>
        <div class="row tree-row with-title">
          <tree-editor #occupationsTree [avaialbleTreeEditorNodes]="availableOccupations"></tree-editor>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row segment-border segment-fixed-height">
      <div class="row title-row" *ngIf="loadingRegions">
        <i class="fas fa-spinner fa-pulse"></i> Loading Regions...
      </div>
      <div class="col-md-12" *ngIf="!loadingRegions">
        <div class="row title-row">
          <p>
            <b>Select Regions to Include</b>
          </p>
        </div>
        <div class="row tree-row with-title">
          <tree-editor #regionsTree [avaialbleTreeEditorNodes]="availableRegions"></tree-editor>
        </div>
      </div>
    </div>
    <div class="row segment-border segment-fixed-height">
      <div class="row title-row" *ngIf="loadingIndustries">
        <i class="fas fa-spinner fa-pulse"></i> Loading Industries...
      </div>
      <div class="col-md-12" *ngIf="!loadingIndustries">
        <div class="row title-row">
          <p>
            <b>Select Industries to Include</b>
          </p>
        </div>
        <div class="row tree-row with-title">
          <tree-editor #industriesTree [avaialbleTreeEditorNodes]="availableIndustries"></tree-editor>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-4">
    <div class="row segment-border">
      <div class="row title-row">
        <p>
          <b>Select Organizations to Include</b>
        </p>
      </div>
      <div class="row input-row">
        <div class="col-md-10 input-column">
          <mat-chip-list #organizationChipList>
            <div class="mat-input">
              <input placeholder="Organization Search..."
                     [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                     [matChipInputFor]="organizationChipList"
                     [matChipInputAddOnBlur]="true"
                     (matChipInputTokenEnd)="addOrganizationSearch($event)" />
            </div>
            <mat-chip *ngFor="let organization of organizationSearch" [selectable]="true" [removable]="true" (removed)="removeOrganizationSearch(company)">
              {{organization}}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
          </mat-chip-list>
        </div>
        <div class="col-md-1 button-column">
          <button mat-button class="piButton" (click)="toggleOrganizationAndOr()">
            <ng-container *ngIf="organizationIsAnd">And</ng-container>
            <ng-container *ngIf="!organizationIsAnd">Or</ng-container>
          </button>
        </div>
      </div>
    </div>
    <div class="row segment-border segment-fixed-height">
      <div class="row title-row" *ngIf="loadingOrganizations">
        <i class="fas fa-spinner fa-pulse"></i> Loading Organizations...
      </div>
      <div class="col-md-12">
        <div class="row tree-row">
          <tree-editor #organizationsTree [avaialbleTreeEditorNodes]="availableOrganizations"></tree-editor>
        </div>
      </div>
    </div>
  </div>
</div>
